import { Button } from 'antd';
import React from 'react';
import { MatchPlayerVm } from '../../../../utils/api';
import CapGrid from './CapGrid';

export type GoalType = 'regular' | 'penalty';
/** null = ordinary exclusion (just pick a player). */
export type FoulModifier = 'brutality' | 'suspension' | 'penalty' | null;

interface EventEntryPanelProps {
    flow: 'goal' | 'foul';
    side: 'home' | 'away';
    players: MatchPlayerVm[];
    goalType: GoalType;
    foulModifier: FoulModifier;
    onSetGoalType: (type: GoalType) => void;
    onSetFoulModifier: (modifier: FoulModifier) => void;
    onPick: (player: MatchPlayerVm) => void;
    onCancel: () => void;
}

const EventEntryPanel: React.FC<EventEntryPanelProps> = ({
    flow,
    side,
    players,
    goalType,
    foulModifier,
    onSetGoalType,
    onSetFoulModifier,
    onPick,
    onCancel,
}) => {
    // Tapping an active modifier again clears it (back to ordinary exclusion).
    const toggleModifier = (modifier: Exclude<FoulModifier, null>): void =>
        onSetFoulModifier(foulModifier === modifier ? null : modifier);

    return (
        <div className="m-entry">
            <div className="m-entry__title">{flow === 'goal' ? 'GOAL' : 'PERSONAL FOUL'}</div>

            {flow === 'goal' ? (
                <div className="m-entry__seg">
                    <button
                        type="button"
                        className={`m-seg__btn${goalType === 'regular' ? ' is-active' : ''}`}
                        onClick={(): void => onSetGoalType('regular')}
                    >
                        Regular
                    </button>
                    <button
                        type="button"
                        className={`m-seg__btn${goalType === 'penalty' ? ' is-active' : ''}`}
                        onClick={(): void => onSetGoalType('penalty')}
                    >
                        Penalty
                    </button>
                </div>
            ) : (
                <>
                    <div className="m-entry__mods">
                        <button
                            type="button"
                            className={`m-mod m-mod--brutality${
                                foulModifier === 'brutality' ? ' is-active' : ''
                            }`}
                            onClick={(): void => toggleModifier('brutality')}
                        >
                            Violent play
                        </button>
                        <button
                            type="button"
                            className={`m-mod m-mod--suspension${
                                foulModifier === 'suspension' ? ' is-active' : ''
                            }`}
                            onClick={(): void => toggleModifier('suspension')}
                        >
                            With suspension
                        </button>
                        <button
                            type="button"
                            className={`m-mod m-mod--penalty${
                                foulModifier === 'penalty' ? ' is-active' : ''
                            }`}
                            onClick={(): void => toggleModifier('penalty')}
                        >
                            Penalty
                        </button>
                    </div>
                    <div className="m-entry__hint">
                        For an ordinary exclusion just pick a player.
                    </div>
                </>
            )}

            <CapGrid players={players} side={side} onPick={onPick} />

            <Button block className="m-entry__cancel" onClick={onCancel}>
                Cancel
            </Button>
        </div>
    );
};

export default EventEntryPanel;
